<div class="card m-3">
  <div class="card-header">
    <h3 class="card-title">
      Benutzer - Liste
      <small *ngIf="loading">Lädt...</small>

      <span class="pull-right">
        <a [routerLink]="['/benutzer/neu']" class="btn btn-success">
          <i class="fa fa-plus"></i> Neuen Benutzer anlegen
        </a>
      </span>
    </h3>
  </div>

  <table class="table table-striped" *ngIf="entities.length > 0">
    <thead>
      <tr>
        <th>
          ID
        </th>
        <th>
          Benutzername
        </th>
        <th>
          Aktiv
        </th>
        <th class="right-align">Aktionen</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let user of entities">
        <td>
          {{ user.id }}
        </td>
        <td>
          <a [routerLink]="['/benutzer', user.id]">
            {{ user.username }}
          </a>
        </td>
        <td>
          <span *ngIf="user.enabled">Ja</span>
          <span *ngIf="!user.enabled">Nein</span>
        </td>
        <td class="right-align">
          <a (click)="onDelete($event, user)" href="#" class="btn btn-danger btn-sm" title="Löschen">
            <i class="fa fa-trash-o"></i>
            <span class="visually-hidden">Benutzer {{ user.username }} löschen</span>
          </a>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="card-body" *ngIf="!loading && entities.length === 0">
    <div class="alert alert-info">
      Es wurden keine Einträge gefunden.
    </div>
  </div>

  <div *ngIf="entities.length" class="card-footer">
    <div class="d-flex flex-row justify-content-end">
      <p-paginator currentPageReportTemplate="Zeige Einträge {first} bis {last} von {totalRecords}."
        [showCurrentPageReport]="true" [rows]="size" [rowsPerPageOptions]="[10,20,50,100,200,{showAll:'Alle'}]"
        [totalRecords]="totalsize" (onPageChange)="handlePageChange($event)"></p-paginator>
    </div>
  </div>
</div>
